import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/MachineMaintenanceSummaryListPlannedActions";
import * as api from "../../api/MachineMaintenanceSummaryListPlannedApi";
import { showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getAreaGroupListPlanned({ payload }) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getAreaGroupListPlanned(payload);
        yield put(actions.setAreaGroupListPlanned(data || undefined));
    } catch (error) {
        yield put(actions.setAreaGroupListPlanned(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getMainEquipmentListPlanned({ payload }) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getMainEquipmentListPlanned(payload);
        yield put(actions.setMainEquipmentListPlanned(data || undefined));
    } catch (error) {
        yield put(actions.setMainEquipmentListPlanned(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getSubEquipmentListPlanned({ payload }) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getSubEquipmentListPlanned(payload);
        yield put(actions.setSubEquipmentListPlanned(data || undefined));
    } catch (error) {
        yield put(actions.setSubEquipmentListPlanned(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getSubEquipmentsTaskListPlanned({ payload }) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getSubEquipmentsTaskListPlanned(payload);
        yield put(actions.setSubEquipmentsTaskListPlanned(data || undefined));
    } catch (error) {
        yield put(actions.setSubEquipmentsTaskListPlanned(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getMaintenanceTypeData({ payload }) {
    try {
        const { data } = yield api.getMaintenanceTypeData(payload);
        yield put(actions.setMaintenanceTypeData(data.resultObject || undefined));
    } catch (error) {
        yield put(actions.setMaintenanceTypeData(undefined));
        yield put(showErrorSnackbar(error));
    }
}
function* getPoolData(action) {
    try {
        const { data } = yield api.getPoolData(action.payload);
        yield put(actions.setPoolData(data || undefined));
    } catch (error) {
        yield put(actions.setPoolData(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_AREA_GROUP_LIST_PLANNED, getAreaGroupListPlanned);
    yield takeEvery(actions.Types.GET_MAIN_EQUIPMENT_LIST_PLANNED, getMainEquipmentListPlanned);
    yield takeEvery(actions.Types.GET_SUB_EQUIPMENT_LIST_PLANNED, getSubEquipmentListPlanned);
    yield takeEvery(actions.Types.GET_SUB_EQUIPMENTS_TASK_LIST_PLANNED, getSubEquipmentsTaskListPlanned);
    yield takeEvery(actions.Types.GET_MAINTENANCE_TYPE_DATA, getMaintenanceTypeData);
    yield takeEvery(actions.Types.GET_POOL_DATA, getPoolData);
}

const MachineMaintenanceSummaryListSaga = [fork(watchAll)];

export default MachineMaintenanceSummaryListSaga;
